<template>
  <div class="draw-circle">
    <canvas :id="myCanvas" width="72" height="72"></canvas>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['value', 'myCanvas'],
  mounted () {
    this.init(this.value)
  },
  methods: {
    init (endNum) {
      let maxPro = 100
      let size = 72
      let speed = 1
      let SCALE = 2
      let canvas = document.getElementById(this.myCanvas)
      if (canvas.getContext) {
        let ctx = canvas.getContext('2d')
        canvas.width = SCALE * canvas.width
        canvas.height = SCALE * canvas.height
        ctx.beginPath()
        ctx.lineWidth = 4 * SCALE
        ctx.strokeStyle = '#383B3F'
        ctx.arc(size / 2 * SCALE, size / 2 * SCALE, 32 * SCALE, 0, Math.PI * 2, true)
        ctx.stroke()
        const timer = setInterval(() => {
          if (speed >= endNum) {
            speed = endNum
            clearInterval(timer)
          }
          ctx.beginPath()
          ctx.lineCap = 'round'
          ctx.lineWidth = 4 * SCALE
          ctx.strokeStyle = '#D7B375'
          const start = Math.PI * 1.5
          const rate = speed / maxPro
          const end = 2 * Math.PI * rate - Math.PI / 2 // 画圆起点移到12点位置
          ctx.arc(size / 2 * SCALE, size / 2 * SCALE, 32 * SCALE, start, end)
          ctx.stroke()
          speed++
        }, 20)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.draw-circle {
  width: 72px;
  height: 72px;

  & canvas {
    width: 100%;
  }
}
</style>
